import { SearchOutlined } from '@ant-design/icons';
import { Flex, Input, Space, Switch, theme, Typography } from 'antd';
import { type ReactNode, useEffect, useState } from 'react';

export interface CustomersFiltersProps {
  onChange?: (filters: FiltersState) => void;
  initialFilters: FiltersState;
}

interface FiltersState {
  query: string;
  showInActive?: boolean;
  clientTags?: number[];
}

const CustomersFilter = (props: CustomersFiltersProps): ReactNode => {
  const { initialFilters, onChange } = props;
  const [filters, setFilter] = useState<FiltersState>(initialFilters);
  const { token } = theme.useToken();
  // const clientTags = useQuery<ClientTag[]>([
  //   'client-tag',
  //   { page: { limit: 10000 }, sort: 'name' },
  // ]);

  useEffect(() => {
    onChange?.(filters);
  }, [filters]);

  return (
    <Flex gap={token.paddingXS}>
      <Input
        allowClear
        value={filters?.query}
        placeholder="Search"
        prefix={<SearchOutlined />}
        onChange={(e) => {
          setFilter((prev) => ({
            ...prev,
            query: e.target?.value || '',
          }));
        }}
        style={{ maxWidth: 300, marginInlineEnd: token.marginMD }}
      />

      {/* <FilterSelect
        value={filters?.clientTags}
        canSelectAll
        mode="multiple"
        options={clientTags.data}
        optionValueProp="id"
        optionLabelProp="name"
        title="Tag"
        onChange={(value) => {
          setFilter((prev) => ({
            ...prev,
            clientTags: value,
          }));
        }}
      /> */}
      <Space size="small" style={{ display: 'flex', minWidth: 120 }}>
        <Typography.Text strong>Inactive</Typography.Text>
        <Switch
          defaultChecked={filters.showInActive}
          onChange={(value: any) => {
            setFilter((prev) => ({
              ...prev,
              showInActive: value,
            }));
          }}
        />
      </Space>
    </Flex>
  );
};

CustomersFilter.defaultProps = {
  onChange: () => {},
};

export default CustomersFilter;
